import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';
import { DateFormatPipe } from './dateformat.pipe';
import { BatchTypePipe } from './batch-type.pipe';
import { DateFilterPipe } from './date-filter.pipe';
import { FilterByQpCodePipe } from './filter-by-qp-code.pipe';
import { FilterByDistrictsPipe } from './filter-by-districts.pipe';
import { FilterByStatesPipe } from './filter-by-states.pipe';
import { MapToKeysPipe } from './map-to-keys.pipe';
import { NumberToWordsPipe } from './number-to-words.pipe';
import { SortArrayByKeyPipe } from './sort-array-by-key.pipe';
import { DayPipe } from './day';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [SearchPipe, DateFormatPipe,
		BatchTypePipe, DateFilterPipe, FilterByQpCodePipe, FilterByDistrictsPipe,
		FilterByStatesPipe, MapToKeysPipe, NumberToWordsPipe, SortArrayByKeyPipe, DayPipe],
	exports: [SearchPipe, DateFormatPipe, BatchTypePipe, DateFilterPipe,
		FilterByQpCodePipe, FilterByDistrictsPipe, FilterByStatesPipe, MapToKeysPipe,
		NumberToWordsPipe, SortArrayByKeyPipe, DayPipe]
})
export class PipesModule { }
